module.exports = {
    portfolio: [
        {
            name: 'CoinMarketCap Blockchain Clone',
            description:
                'A follow top digital assets and preview trades using blockchain technology and Solidity contract backend',
            link: 'https://youtu.be/13SdluC5_n0',
            video: 'https://youtu.be/13SdluC5_n0',
            image: 'cmc-clone',
            github: 'https://github.com/K-G-J/coinmarketcap-clone-blockchain',
        },

        {
            name: 'Digital Asset Portfolio Calculator',
            description: 'CoinGeko API and custom backend price calculation formula',
            link: 'https://crypto-dex.herokuapp.com/',
            video: 'https://youtu.be/cKy3Gu-WAb4',
            image: 'crypto-calculator',
            github: 'https://github.com/K-G-J/crypto-calculator',
        },

        {
            name: 'Full Stack Digital Asset Minting Website',
            description: 'Smart contract powered site for minting an NFT collection',
            link: 'https://k-g-j.github.io/full-mint-website-front-end/',
            video: 'https://youtu.be/NHhGqVrhNQQ',
            image: 'full-mint',
            github: 'https://github.com/K-G-J/full-mint-website-front-end',
        },
        {
            name: 'Blockchain Twitter Clone',
            description:
                'Mint profile NFTs, post tweets, tip tweets of other users with cryptocurrency',
            link: 'https://youtu.be/iy3TrL8yChc',
            video: 'https://youtu.be/iy3TrL8yChc',
            image: 'twitter-clone',
            github: 'https://github.com/K-G-J/twitter-blockchain-clone',
        },
        {
            name: 'Spooky Hollow Augmented Reality Markplace',
            description:
                'A fully functional NFT marketplace for minitng, buying, and trading augmented reality NFTs',
            link: 'https://youtu.be/HQo_A0LOlrg',
            video: 'https://youtu.be/HQo_A0LOlrg',
            image: 'spooky-hollow',
            github: 'https://github.com/K-G-J/spooky-hollow',
        },
        {
            name: 'Krypt',
            description: 'A beautiful and fun app for buying and sending crypto and a fun GIF message',
            link: 'https://krypt-gif.com/',
            video: 'https://youtu.be/gPebC7jLgRE',
            image: 'krypt',
            github: 'https://github.com/K-G-J/krypt',
        },
        {
            name: 'Trading Portfolio Dashboard',
            description:
                'Dashboard to view all user transactions, accounts, NFTs, and send crypto',
            link: 'https://youtu.be/SlghW9vYiK8',
            video: 'https://youtu.be/SlghW9vYiK8',
            image: 'dashboard3',
            github: 'https://github.com/K-G-J/Dashboard3',
        },
        {
            name: 'NFT-y',
            description:
                'See user digital assets, search blockchain NFTs, add favorites, live chat with other users',
            link: 'https://nft-y.herokuapp.com/',
            video: 'https://youtu.be/oiJZGTgtXdU',
            image: 'nft-y',
            github: 'https://github.com/K-G-J/nft-y',
        },
        {
            name: 'Lazy Mint NFTs',
            description: 'Upload and mint NFTs to Rarible without paying any fees',
            link: 'https://youtu.be/eVfqcp6XUu4',
            video: 'https://youtu.be/eVfqcp6XUu4',
            image: 'lazy-mint',
            github: 'https://github.com/K-G-J/nft-minter',
        },
        {
            name: 'Crowdfund Solidity Hardhat Project',
            description: 'A Solidity smart contract project to hold and raise money for crowdfounding, accompanied by tests and scripts',
            link: 'https://youtu.be/Dhje-1qkttQ',
            video: 'https://youtu.be/Dhje-1qkttQ',
            image: 'crowdfund',
            github: 'https://github.com/K-G-J/metacrafters-crowdfund',
        },
        {
            name: 'Market Sentiment App',
            description: 'Vote on your confidence in various stocks and digital assets to watch bobbles change',
            link: 'https://youtu.be/RCr-lFwChp8',
            video: 'https://youtu.be/RCr-lFwChp8',
            image: 'market-sentiment',
            github: 'https://github.com/K-G-J/MarketSentiment-Dapp',
        },
        {
            name: 'Secret Sauce',
            description:
                'An app to share secret recipes with whitelisted addresses and upload images to ipfs',
            link: 'https://youtu.be/gzaM00JsGhQ',
            video: 'https://youtu.be/gzaM00JsGhQ',
            image: 'secret-recipe',
            github: 'https://github.com/K-G-J/secret-sauce',
        },
    ],
}
